// extracted by mini-css-extract-plugin
export default {"title":"LdapLogin_title__fu4aU"};